import { Fragment } from 'react'

import { useReveal } from '@/lib/useReveal'

interface Props {
  text: string
  className?: string
}

/**
 * Section headline that rises in per character on scroll.
 *
 * The hover wave and the reveal share the `.title__char` element but use
 * different transition properties, so hovering mid-reveal does not fight it.
 */
export function SplitTitle({ text, className = '' }: Props) {
  const { ref, inView } = useReveal<HTMLSpanElement>({ threshold: 0.25 })

  let index = 0

  const words = text.split(' ')

  return (
    <span ref={ref} className={`split-title ${className}`.trim()}>
      {words.map((word, wi) => (
        <Fragment key={`${word}-${wi}`}>
          {/* A real space text node between words. Flexbox does not render
              whitespace-only anonymous items, so the visual gap still comes
              from the `gap` property — but the DOM text stays a readable
              sentence for screen readers, search engines and copy-paste.
              Without this the heading exposes as "Fivedomains.Oneplatform." */}
          {wi > 0 ? ' ' : null}
          <span className="split-title__word">
            {Array.from(word).map((ch, ci) => (
              <span
                key={`${ch}-${ci}`}
                className="split-title__char"
                data-in={inView}
                style={{ ['--i' as string]: index++ }}
              >
                {ch}
              </span>
            ))}
          </span>
        </Fragment>
      ))}
    </span>
  )
}
